require('smoothscroll-polyfill').polyfill();
//require('./../../../../node_modules/bootstrap.native/lib/utils')
//require('./../../../../node_modules/bootstrap.native/lib/modal-native')


let issuuButtons = document.getElementsByClassName('issuu-trigger-button');

if (issuuButtons.length) {
  for (let i = 0; i < issuuButtons.length; i ++) {
    issuuButtons[i].addEventListener('click', e => {
      e.preventDefault()

      document.body.classList.toggle('no-overflow-x')
      document.documentElement.classList.toggle('no-overflow-x')
      document.body.style.height = 'auto'
      document.documentElement.style.height = 'auto'

      document.getElementById('issuu-embed-container').classList.remove('issuu-embed-container-hidden')

      let scrollTarget = document.getElementById('issuu-scroll-target')
      let offsets = scrollTarget.getBoundingClientRect()

      setTimeout(() => {
        let offsets = scrollTarget.getBoundingClientRect()

        window.scroll({
          top: offsets.top,
          right: offsets.right,
          behavior: 'smooth'
        })
      }, 200)

      setTimeout(() => {
        document.body.classList.toggle('no-overflow-x')
        document.documentElement.classList.toggle('no-overflow-x')
        window.scroll({
          top: offsets.top,
          right: offsets.right
        })
      }, 1000)
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/includes/publication.js